import cardStyle from './cardStyle.js'
const [ANDROIDPC, PC] = [1, 2];
const [LogoTypeImg, LogoTypeTxt] = [0, 1]

const isSupportTouch = ('ontouchstart' in window);
const Events = {
  touchStart: isSupportTouch ? 'touchstart' : 'mousedown',
  touchMove: isSupportTouch ? 'touchmove' : 'mousemove',
  touchEnd: isSupportTouch ? 'touchend' : 'mouseup'
}

const ajaxState = {
  noajax: 0,
  working: 1,
  error: 2,
  success: 3,
  failed: 4,
  badnetwork: 5,
  pageConfigSuccess: 6
}
const tips = {
  'search_working': '正在查询中...',
  'search_success': '查询成功，正在跳转...',
  'search_failed': '您输入的编码不正确或不存在，请重新尝试！',
  'bad_network': '网络不好，请稍后再试',
  'btn_try_again': '重新查询',
  'page_config_success': '个性化设置成功'
}
export default {
  ANDROIDPC,
  PC,
  LogoTypeImg,
  LogoTypeTxt,
  Events,
  ajaxState,
  tips,
  cardStyle
}



// WEBPACK FOOTER //
// ./src/enums/index.js